// @ts-nocheck
export const localeCodes =  [
  "ar",
  "cav",
  "en",
  "mr",
  "de",
  "ru",
  "fr",
  "ms",
  "far",
  "ha",
  "gr",
  "end",
  "bn",
  "kr",
  "nl",
  "ta",
  "bsn"
]
export const localeLoaders = {
  ar: [
    {
      key: "locale_ar_46json_223a5e9d",
      load: () => import("#nuxt-i18n/223a5e9d" /* webpackChunkName: "locale_ar_46json_223a5e9d" */),
      cache: true
    }
  ],
  cav: [
    {
      key: "locale_ar_46json_223a5e9d",
      load: () => import("#nuxt-i18n/223a5e9d" /* webpackChunkName: "locale_ar_46json_223a5e9d" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  mr: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ms: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  far: [
    {
      key: "locale_ar_46json_223a5e9d",
      load: () => import("#nuxt-i18n/223a5e9d" /* webpackChunkName: "locale_ar_46json_223a5e9d" */),
      cache: true
    }
  ],
  ha: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  gr: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  end: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  bn: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  kr: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ta: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  bsn: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = [
  {
    code: "ar",
    language: "ar"
  },
  {
    code: "cav",
    language: "ms-Arab"
  },
  {
    code: "en",
    language: "en",
    isCatchallLocale: true
  },
  {
    code: "mr",
    language: "mos"
  },
  {
    code: "de",
    language: "de"
  },
  {
    code: "ru",
    language: "ru"
  },
  {
    code: "fr",
    language: "fr"
  },
  {
    code: "ms",
    language: "ms"
  },
  {
    code: "far",
    language: "fa"
  },
  {
    code: "ha",
    language: "ha"
  },
  {
    code: "gr",
    language: "ka"
  },
  {
    code: "end",
    language: "id"
  },
  {
    code: "bn",
    language: "bn"
  },
  {
    code: "kr",
    language: "ky"
  },
  {
    code: "nl",
    language: "nl"
  },
  {
    code: "ta",
    language: "ta"
  },
  {
    code: "bsn",
    language: "bs"
  }
]
/** client **/

/** client-end **/